import { FC } from 'react';
import Drawer from '..';
import DrawerHeader from '../header';
import DrawerContent from '../content';
import { useQuery } from 'react-query';
import { getPublicServiceById } from '@/lib/services/public-service.service';
import { PublicServiceModel } from '@/lib/models/public-service/public-service.model';
import { QueryKey } from '@/lib/query-client';
import CompanyProfile from './company-profile';
import ServiceDetails from './service-details';
import PublicServiceUsage from './usage';
import Stack from '@mui/material/Stack';
import Risk from './risk';
import RouterTabs from '@/components/router-tabs';
import StatusChip from '@/components/chip/status-chip';
import ServiceLink from '@/components/service-link';
import { DrawerProps } from '../helpers';

interface Props extends DrawerProps {
  id: string;
}

export const PublicServiceDrawer: FC<Props> = ({ id, open, onClose, className, isTopDrawer }) => {
  const query = useQuery([QueryKey.PublicServiceView, id], async () => getPublicServiceById(id), {
    enabled: !!id,
  });

  const { data = new PublicServiceModel() } = query;
  const publicModel = data || new PublicServiceModel();

  const { status } = publicModel;
  const showStatus = status !== 'available';

  return (
    <Drawer
      open={open}
      onClose={onClose}
      isTopDrawer={isTopDrawer}
      className={className}
      query={query}
      size="large"
    >
      <DrawerHeader onClose={onClose}>
        <Stack direction="row" width="100%" gap={4}>
          <Stack direction="row" gap={2} alignItems="center">
            <ServiceLink service={publicModel} size="large" action="none" />
            {showStatus && <StatusChip value={status} size="small" />}
          </Stack>
        </Stack>
      </DrawerHeader>
      <DrawerContent>
        <RouterTabs
          variant="drawer"
          panels={[
            {
              label: 'Service Details',
              icon: 'info-circle',
              path: 'profile',
              component: <ServiceDetails publicService={publicModel} />,
            },
            {
              label: 'Usage',
              icon: 'policy',
              path: 'usage',
              component: <PublicServiceUsage publicServiceId={publicModel.id} />,
            },
            {
              label: 'Risk',
              icon: 'risk',
              path: 'risk',
              component: <Risk publicService={publicModel} />,
            },
            {
              label: 'Company Profile',
              icon: 'organization',
              path: 'model-and-prompt',
              component: <CompanyProfile publicService={publicModel} />,
            },
          ]}
        />
      </DrawerContent>
    </Drawer>
  );
};

export default PublicServiceDrawer;
